<template>
  <div>
    <el-dialog
      :title="title"
      :visible.sync="setShow"
      :close-on-click-modal="closable"
      :show-close="closable"
      :close-on-press-escape="closable"
      width="28%"
      @close="close"
    >
      <el-form :model="form" label-position="top" ref="form" @submit.prevent>
        <el-row type="flex">
          <el-col :span="24">
            <el-form-item
              label="Name"
              prop="name"
              :rules="validateField('Name')"
            >
              <el-input type="text" v-model="form.name" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row type="flex">
          <el-col :span="24">
            <el-form-item
              label="Address"
              prop="address"
              :rules="validateField('Address')"
            >
              <el-input type="text" v-model="form.address" />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer">
        <el-button v-if="closable" plain size="medium" @click="close"
          >Cancel</el-button
        >
        <el-button
          type="primary"
          size="medium"
          :loading="creating"
          @click="create"
          >Create</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getUserOrganisations } from "@/lib/utils";
import apiConstants from "@/apiConstants";

export default {
  name: "OrganisationAdd",
  props: {
    show: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: "Create new organisation"
    },
    closable: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      form: {
        name: "",
        address: ""
      },
      creating: false,
      noAccessCodes: apiConstants.NO_ACCESS_CODES
    };
  },
  computed: {
    setShow: {
      get() {
        return this.show;
      },
      set(value) {
        this.$emit("update:show", value);
      }
    },
    organisation() {
      return this.$store.getters.organisation.summary;
    }
  },
  methods: {
    close() {
      this.form = {
        name: "",
        address: ""
      };
      this.setShow = false;
    },
    create() {
      this.$refs.form.validate(async valid => {
        if (!valid) {
          this.creating = false;
          return false;
        }

        this.creating = true;
        this.$http
          .post("organisations", {
            body: this.form,
            method: "POST"
          })
          .then(response => {
            const resData = response.data;
            if (resData.status === "error") {
              this.handleErrors(resData);
              this.creating = false;
            } else {
              this.getOrganisations();
              this.notification(
                "Completed",
                "Organisation created successfully",
                "success"
              );
              this.$emit("added", resData.id);
              this.creating = false;
              this.close();
            }
          })
          .catch(() => {
            this.notification("Error", "An unknown error occurred", "danger");
            this.creating = false;
          });
      });
    },
    getOrganisations() {
      getUserOrganisations(this.$http)
        .then(response => {
          const resData = response.data;
          if (resData.status === "error") {
            this.handleErrors(resData);
          }
        })
        .catch(() => {
          this.notification("Error", "An unknown error occurred", "danger");
        });
    }
  }
};
</script>

<style lang="scss" scoped></style>
